var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"overflow-hidden",style:({ height: _vm.height }),attrs:{"no-body":""}},[_c('b-skeleton-img',{attrs:{"width":_vm.width,"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }